module.exports = __webpack_public_path__ + "static/img/jia.4a17644.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/jia.jpg
// module id = 3Gxl
// module chunks = 0